import { api } from '@/api/client';
import {
  studioClickResponseSchema,
  studioLikeResponseSchema,
  studiosResponseSchema,
} from '@/lib/validation';
import type { Studio, StudioClickResponse, StudioLikeResponse } from '@/types';

export function getStudios(): Promise<Studio[]> {
  return api('/studios', {
    responseSchema: studiosResponseSchema,
  });
}

export function incrementStudioClick(studioId: number): Promise<StudioClickResponse> {
  return api(`/studios/${studioId}/click`, {
    method: 'POST',
    responseSchema: studioClickResponseSchema,
  });
}

export function toggleStudioLike(studioId: number, liked: boolean): Promise<StudioLikeResponse> {
  return api(`/studios/${studioId}/like`, {
    method: 'POST',
    body: JSON.stringify({ liked }),
    responseSchema: studioLikeResponseSchema,
  });
}
